import gql from 'graphql-tag';

export default gql`
  query ArtistDetails($id: ID, $slug: String) {
    artist(id: $id, slug: $slug) {
      id
      slug
      agency
      agencyEmail
      agencyWeb
      favorite
      name
      lastname
      birthday
      email
      interests
      infoType
      cv {
        name
        url
      }
      work_experience {
        title
        theater
        stageDirector
        conductor
        role
        year
      }
      formal_education {
        title
        from {
          month
          year
        }
        to {
          month
          year
        }
      }
      informal_education {
        title
        from {
          month
          year
        }
        to {
          month
          year
        }
      }
      support {
        title
        from {
          month
          year
        }
        to {
          month
          year
        }
      }
      clips {
        url
      }
      achievements {
        title
        year
      }
      facebook
      twitter
      linkedin
      youtube
      soundcloud
      website
      biography
      nationality
      residence
      profession
      specialty
      active
      showAge
      type
      images {
        url
      }
      videos {
        url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/ArtistDetails.js